<div class="wrapper">
    <div class="popup">
        {$crash}
    </div>
</div>

<style>
.wrapper {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;    
    background-color: #000000CD;
    display: flex;
    justify-content: center;
    align-items: center;
}
.popup{
    max-width: 400px;
    background-color: var(--kilo);
    color: #fff;
    padding: 50px;
    border-radius: 30px;
    text-align: center;
}
</style>

<script>
import { crash, version } from "../stores/index"
</script>